import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IGrammarCurriculumBatch } from '../schemas';
import type { IImportGrammarCurriculumV1Response } from './import-grammar-curriculum-v1-response';
import { importGrammarCurriculumV1ResponseSchema } from './import-grammar-curriculum-v1-response';

export async function importGrammarCurriculumV1Api(
  body: IGrammarCurriculumBatch,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IImportGrammarCurriculumV1Response>> {
  return postRequest<IImportGrammarCurriculumV1Response>({
    path: '/sys/grammar/v1/import',
    body,
    schema: importGrammarCurriculumV1ResponseSchema,
    options,
  });
}
